import { createApp } from 'vue'
import { pinia } from "@/store";
import { createPinia } from "pinia";
import i18n from './Lang/lang'
import App from './App.vue'
//import Vue from 'vue'
import router from './router'
import "primevue/resources/primevue.min.css";
import "primevue/resources/themes/saga-blue/theme.css";
import './assets/css/css/animate.css'
import './assets/css/css/datepicker.min.css'
import './assets/cssNew/css/primeicons.css'
import 'vue3-easy-data-table/dist/style.css';
import 'vue-loading-overlay/dist/css/index.css';
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import './assets/css/css/main.css'

//Designer Js
import VueFeather from 'vue-feather';
import 'feather-icons'
import 'vue-feather-icons'
//import './assets/css/js/feather-icon/feather-icon.js';
//import './assets/css/js/feather-icon/feather.min.js';
import '@/assets/css/js/admin-script.js'
import sidebarJs from './assets/css/js/sidebar.js';
//import './assets/css/js/date-picker.js';
//import './assets/css/js/dropzone/dropzone-script.js';
//import './assets/css/js/dropzone/dropzone.js';

/*import CKEditor from '@ckeditor/ckeditor5-vue';*/
import setupInterceptors from './service/setupInterceptors';
import externalapisetupInterceptors from './service/ExternalApiSetupInterceptors';
import axios from 'axios';
import $toast from '@meforma/vue-toaster';
import { LoadingPlugin } from 'vue-loading-overlay';
import Vue3EasyDataTable from 'vue3-easy-data-table';
//import { Device } from 'twilio-client';
import LoadScript from "vue-plugin-load-script";

import loadCustomJs from "./assets/CustomJs/front.js"
import VueYupFormValidation from 'vue-yup-form-validation';
import DynamicMultiSelect from 'vue-dynamic-multiselect';
import DynamicSelect from 'vue-dynamic-select';
import PrimeVue from 'primevue/config';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColorPicker from 'primevue/colorpicker';
import Paginator from 'primevue/paginator';
import InputMask from 'vue-input-mask';
import * as ConfirmDialog from "vuejs-confirm-dialog";
import GoogleMap from "./views/crm/shared/google-map/GoogleMap.vue"

import Loading from '@/layouts/loader/loader.vue';
import FilterUtility from '@/helpers/FilterUtility.js';
import configuration from '@/helpers/configuration.js';
import dynamicUiText from '@/helpers/dynamicUiText.js';
import CKEditor from '@mayasabha/ckeditor4-vue3';
import { vMaska } from "maska";
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';
import MultiSelect from 'primevue/multiselect';
import Checkbox from 'primevue/checkbox';
import VueHtmlToPaper from "./views/shared/VueHtmlToPaper";
import InputMasks from 'primevue/inputmask';
import VueApexCharts from "vue3-apexcharts";
import $ from 'jquery';
import { initLoginSourceDetection } from '@/helpers/loginSource';
window.$ = window.jQuery = $;
import 'summernote/dist/summernote-bs5.css';
import 'summernote/dist/summernote-bs5.js';

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
// Tooltip fallback (in case)
if (!$.fn.tooltip) {
    $.fn.tooltip = function () {
        return this;
    };
}
/* --- Polyfill Bootstrap jQuery modal for Summernote --- */
if (!$.fn.modal) {
    $.fn.modal = function (action) {
        this.each(function () {
            const modalEl = this;
            if (action === 'show') {
                const modal = new bootstrap.Modal(modalEl);
                modal.show();
            } else if (action === 'hide') {
                const modal = bootstrap.Modal.getInstance(modalEl);
                if (modal) modal.hide();
            }
        });
        return this;
    };
}

const app = createApp(App).use(router).use(setupInterceptors).use(externalapisetupInterceptors).use(LoadingPlugin).use(ConfirmDialog).use(Vue3EasyDataTable).use(i18n)

app.config.globalProperties.$filters = FilterUtility;
app.config.globalProperties.$custConfig = configuration;
app.config.globalProperties.$uiText = dynamicUiText;
//app.config.globalProperties.$TNYCkEditorKey = 'ddpmqsbd835x7yco1xkhj8zy4qczxqv4i2fwie2huasi18at';
//app.config.globalProperties.$TNYCkEditorKey = 'y1hwp8c4uqe4f4j775akg07u8p664wvhwj86fjgfswaq2eya';
app.config.globalProperties.$TNYCkEditorKey = '337oynl3bnxwxz357zv9n68vwnsgci3z6a1np1dtd3079hxf';


window.$ = window.jQuery = require('jquery');
app.provide('axios', axios)
    //app.provide('Device', { Device })


app.mixin("", loadCustomJs);
app.mixin("", sidebarJs);
//app.use({ Device });
app.use(pinia).use(DynamicMultiSelect).use(DynamicSelect);
app.use($toast, { position: 'top-right', duration: 5000 });
// zIndex: PrimeVue overlay defaults (1000) sit below Bootstrap 5 modals in admin.css
// (.modal-backdrop 1040, .modal 1060), so Dropdown/MultiSelect/Calendar panels were
// invisible and non-interactive inside modals. Keep overlay/menu above that stack.
app.use(LoadScript).use(VueYupFormValidation).use(InputMask).use(PrimeVue, {
    zIndex: {
        modal: 1100,
        overlay: 999999,
        menu: 1200,
        tooltip: 1300
    }
}).use(CKEditor);
app.use(createPinia());
app.use(VueHtmlToPaper);
app.use(VueApexCharts);
app.component(VueFeather.name, VueFeather);
app.component('ColorPicker', ColorPicker)
app.component('EasyDataTable', Vue3EasyDataTable);
app.component('DataTable', DataTable);
app.component('Paginator', Paginator);
app.component('Column', Column);
app.component('Calendar', Calendar);
app.component('InputMasks', InputMasks);
app.component('Loading', Loading);
app.component('GoogleMap', GoogleMap);
app.directive('maska', vMaska)
app.mount('#app');

app.component('Dropdown', Dropdown);
app.component('Checkbox', Checkbox);
app.component('MultiSelect', MultiSelect);

//New setup T
app.use(function(req, res, next) {
    const isProduction = process.env.VUE_APP_PRODUCTION;
    if (isProduction == "true") {
        if (location.protocol === 'http:') {
            window.location.href = location.href.replace('http', 'https');
        }
    }
});


function scrollActiveInput() {
    const el = document.activeElement;

    if (!el) return;

    if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'PASSWORD' || el.tagName === 'EMAIL' || el.tagName === 'TEL' || el.tagName === 'IFRAME' || (el.tagName === 'DIV' && el.id === 'payment-type-box')) {
        setTimeout(() => {
            el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }, 300); // wait for keyboard animation
    }
}

if (window.visualViewport) {
    const viewport = window.visualViewport;
    const initialHeight = window.innerHeight;

    viewport.addEventListener('resize', () => {
        const keyboardOpen = viewport.height < initialHeight;

        document.body.classList.toggle('keyboard-open', keyboardOpen);

        if (keyboardOpen) {
            scrollActiveInput();
        }
    });
}

function detectDevice() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // iOS detection
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

    // Android detection
    const isAndroid = /Android/.test(userAgent);

    if (isIOS) {
        document.body.classList.add("iOS");
    } else if (isAndroid) {
        document.body.classList.add("android");
    }
}

document.addEventListener("DOMContentLoaded", detectDevice);

// Run once at boot so loginSource/deviceType are correct before any view reads storage.
// Critical for Chrome Android "Request desktop site" (spoofed Linux UA, real Client Hints).
try {
    initLoginSourceDetection();
} catch (e) {
    console.warn('[LoginSource] boot detection failed', e);
}